import React from 'react'
import { BCardBody, BLink } from '@prague-digi/ui-components'
import { FormattedMessage } from 'react-intl'

import { URL } from '../../../../constants'
import messages from '../../../../i18n'

import styles from './styles.scss'

const msg = messages.recapitulation.disclaimer

export const Disclaimer = () => (
  <BCardBody dark theme="mt-4">
    <p>
      <FormattedMessage {...msg.part1} />
    </p>
    <p>
      <FormattedMessage
        {...msg.part2}
        values={{
          link: (
            <u>
              <BLink
                href={URL.GDPR_MONETA}
                message={<FormattedMessage {...msg.part2Link} />}
                target="_blank"
                type="link"
              />
            </u>
          ),
        }}
      />
    </p>

    <ul className={styles.bullets}>
      <li>
        <FormattedMessage {...msg.part3.item1} />
      </li>
      <li>
        <FormattedMessage {...msg.part3.item2} />
      </li>
      <li>
        <p>
          <FormattedMessage {...msg.part3.item3.title} />
        </p>
        <ol className={styles.letters}>
          <li>
            <FormattedMessage {...msg.part3.item3.a} />
          </li>
          <li>
            <FormattedMessage {...msg.part3.item3.b} />
          </li>
          <li>
            <FormattedMessage {...msg.part3.item3.c} />
          </li>
          <li>
            <FormattedMessage {...msg.part3.item3.d} />
          </li>
          <li>
            <FormattedMessage {...msg.part3.item3.e} />
          </li>
          <li>
            <FormattedMessage {...msg.part3.item3.f} />
          </li>
        </ol>
      </li>
    </ul>

    <p>
      <FormattedMessage {...msg.part4} />
    </p>
    <p>
      <FormattedMessage {...msg.part5} />
    </p>
  </BCardBody>
)

export default Disclaimer
